export const ACTION_TYPES = {
  challenge_request: "challenge_request",
  accept_reject: "accept_reject",
  challenge_response: "challenge_response",
  event_update: "event_update",
  event_canceled: "event_cancelled",
  check_in_reminder: "check_in_reminder",
  check_in_missed: "check_in_missed",
  stream_starting: "stream_starting",
  stream_live_now: "stream_live_now",
  stake_wagered: "stake_wagered",
  stake_lost: "stake_lost",
  stake_won: "stake_won",
  ticket_purchased: "ticket_purchased",
  referral_code_shared: "referral_code_shared",
  milestone_progress: "milestone_progress",
  reward_earned: "reward_earned",
};

export const ACTION_STATUS = {
  pending: "pending",
  accepted: "accepted",
  rejected: "rejected",
  updated: "updated",
  canceled: "cancelled",
  checked_in: "checked_in",
  missed_check_in: "missed_check_in",
  live: "live",
  completed: "completed",
  expired: "expired",
};
